module.exports = __webpack_public_path__ + "img/ss-blog-mobile.f5b35367.jpg";